import { useLocation, useNavigate } from "react-router-dom";
import BreadCumb from "../common/Breadcrumb";
import backArrow from "../../assets/task/back_arrow.svg";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputsNew from "../common/InputsNew";
import SearchableInputsDropdown from "../common/SearchableDropdown";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { uploadFileDirectly } from "../../pages/projects/AddProject";
import plusIconuplad from "../../assets/task/plus_icon_uload.svg";
import { useAuth } from "../../context/AuthContext";
import Loader from "../common/Loader";
import { showError, showSuccess } from "../common/ToastNotification";
import { ApolloError, useMutation } from "@apollo/client";
import { CREATE_DEFECT } from "../../api/mutation";

const severityOptions = [
    {
        key: 101,
        name: "Low"
    },
    {
        key: 102,
        name: "Medium"
    },
    {
        key: 103,
        name: "High"
    },
    {
        key: 104,
        name: "Critical"
    }
]

const addDefectSchema = yup.object().shape({
    title: yup.string()
        .test('not-only-whitespace', 'Please add a valid Title', value => !value || value.trim().length > 0)
        .required('This field is required'),
    severity: yup.string().required('This field is required'),
    description: yup.string()
        .test('not-only-whitespace', 'Please add a valid Title', value => !value || value.trim().length > 0)
        .required('This field is required'),
    // stepsToReproduce: yup.string()
    //     .test('not-only-whitespace', 'Please add valid Steps', value => !value || value.trim().length > 0),
    // expectedBehaviour: yup.string()
    //     .test('not-only-whitespace', 'Please add valid Expected Behaviour', value => !value || value.trim().length > 0),
    // actualBehaviour: yup.string()
    //     .test('not-only-whitespace', 'Please add valid Actual Behaviour', value => !value || value.trim().length > 0),
    imageurl: yup.string(),
    fileName: yup.string(),
});

const AddTicket = () => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate()
    const location = useLocation()

    const { userInfo } = useAuth()
    const employeeID = userInfo?.employee_id || '';
    const employeeEmail = userInfo?.email_id
    const employeeName = `${userInfo?.first_name} ${userInfo?.last_name}`

    const state = location.state as {
        emailTicket: any
    };

    const { emailTicket } = state

    const [imgUrls, setImgUrls] = useState<string[]>([]);
    const [fileNames, setFileNames] = useState<string[]>([]);
    const [isUploading, setIsUploading] = useState<boolean>(false);
    const [validationMessage, setValidationMessage] = useState<string | null>(null);
    const [loading, setLoading] = useState(false)

    //api
    const [createDefect, { loading: createDefectLoading }] = useMutation(CREATE_DEFECT, {
        fetchPolicy: 'no-cache',
    })

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
        trigger,
        watch,
        control,
        getValues
    } = useForm<any>({
        resolver: yupResolver(addDefectSchema)
    });

    //watch
    const watchSeverity = watch('severity')

    useEffect(() => {
        if (emailTicket) {
            setValue('description', emailTicket?.email_body)
        }
    }, [emailTicket])

    function handleSelectSeverity(key: number, name: string): void {
        setValue('severity', name)
        trigger('severity')
    }

    function handleIconClick() {
        fileInputRef.current?.click();
    }

    async function handleFileUpload(event: ChangeEvent<HTMLInputElement>) {
        const files = event.target.files;
        if (!files || files.length === 0) return;

        const token = localStorage.getItem("authToken")!;
        const validTypes = ["image/jpeg", "image/png"];
        // const newImageUrls: string[] = [];
        const newUrls: string[] = [];
        const newNames: string[] = [];

        setIsUploading(true);
        setValidationMessage(null);

        for (const file of Array.from(files)) {
            if (!validTypes.includes(file.type)) {
                setValidationMessage("Only JPG and PNG files are allowed.");
                setIsUploading(false);
                return;
            }

            try {
                const url = await uploadFileDirectly(file, file.name, token);
                newUrls.push(url);
                newNames.push(file.name);
            } catch (err) {
                console.error("Upload failed", err);
            }
        }

        // setImgUrls((prev) => [...prev, ...newImageUrls]);
        setImgUrls((prev) => [...prev, ...newUrls]);
        setFileNames((prev) => [...prev, ...newNames]);
        setIsUploading(false);

        // If needed, set values in your form for each image (optional)
        // e.g., setValue("imageUrls", [...imgUrls, ...newImageUrls])
    }

    const handleRemoveImage = (index: number) => {
        setImgUrls((prev) => prev.filter((_, i) => i !== index));
        setFileNames((prev) => prev.filter((_, i) => i !== index));
    };

    async function onSubmit(data: any) {
        const attatchmentList = imgUrls.map((url, index) => ({
            file_name: fileNames[index],
            file_url: url,
            uploaded_by: parseInt(employeeID),
        }));

        const payload = {
            title: data?.title,
            priority: data?.severity,
            description: data?.description,
            attachments: imgUrls,
            attatchment_list_for_defect: attatchmentList,
            steps_to_reproduce: data?.stepsToReproduce,
            actual_behaviour: data?.actualBehaviour,
            expected_behaviour: data.expectedBehaviour,
            customer_email: emailTicket?.from,
            replied_by_name: employeeName,
            replied_by_email: employeeEmail,
            thread_id: emailTicket.thread_id,
            employee_id: parseInt(employeeID)
        };

        try {
            setLoading(true);

            const response = await fetch(
                "https://n8n-rrjie-u41909.vm.elestio.app/webhook-test/make-ticket-canary",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }

            const result = await response.text();
            showSuccess(result)

            const input = {
                title: data.title,
                description: data.description,
                attachment_list: attatchmentList,
                severity: data.severity,
                created_by: parseInt(employeeID),
                is_issue: true,
                is_confirmed: true,
                confirmed_by: parseInt(employeeID)
            }

            try {
                const response = await createDefect({ variables: { input: input } });
                if (response.data.create_defect.status_code === 201) {
                    showSuccess(response.data.create_defect.message)
                    navigate(-1)
                }
                if (response.data.create_defect.status_code === 400) {
                    showError(response.data.create_defect.message)
                }
            } catch (error) {
                if (error instanceof ApolloError) {
                    showError(error.message)
                }
            }
        } catch (error) {
            console.error("Failed to send to n8n:", error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} id="cts-respon-p-dv" className="w-full  relative  overflow-hidden flex flex-row items-start justify-center flex-wrap content-start py-40 px-20 mq991:p-8 mq575:p-4  box-border text-left text-base text-gray font-manrope">
                <div className="flex-1 flex flex-col items-start justify-start gap-6">
                    <BreadCumb />
                    {/* <div className="self-stretch rounded flex flex-col items-start justify-start text-dimgray">
                                <div className="flex flex-row items-center justify-start">
                                    <div className="overflow-hidden flex flex-row items-center justify-start gap-2">
                                        <div className="relative [text-decoration:underline]">Dashboard</div>
                                        <img className="w-4 relative h-4 overflow-hidden shrink-0" alt="" src="Right 16px.svg" />
                                        <div className="relative font-semibold text-gray">Add New Task</div>
                                    </div>
                                </div>
                            </div> */}
                    <div className="self-stretch flex flex-row items-center justify-start gap-[5px] text-2xl">
                        <img className="w-6 relative h-6 overflow-hidden shrink-0 cursor-pointer dark-white-img" alt="" src={backArrow}
                            onClick={() => navigate(-1)}
                        />
                        <h3 className="m-0 flex-1 relative text-inherit font-bold font-inherit inline-block max-w-[calc(100%_-_29px)] mq450:text-base dark:text-white">Add Ticket</h3>
                    </div>
                    <div className="m-0 self-stretch rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove flex flex-col items-start justify-start p-8 mq575:p-3 box-border gap-spacing-lg max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border">
                        {/* <h5 className="my-0 text-xl-dv self-stretch relative text-lg">Goal Details</h5> */}
                        <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1 mt-[8px] gap-[8px] min-w-full">
                            <InputsNew
                                contentPlaceholder="Title"
                                label="Title*"
                                type="text"
                                register={register('title')}
                                errorMessage={errors.title}
                            />
                            <SearchableInputsDropdown
                                label="Severity*"
                                initialValue={watchSeverity}
                                placeHolder="--Select--"
                                options={severityOptions}
                                onSelect={handleSelectSeverity}
                                errorMessage={errors?.severity}
                            />
                        </div>
                        <div className="self-stretch flex flex-col items-start justify-start text-sm">
                            <div className="self-stretch rounded-radius-md  overflow-hidden flex flex-row items-start justify-start pt-2 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] ">
                                <InputsNew
                                    contentPlaceholder="Description"
                                    label="Description*"
                                    type="textarea"
                                    register={register('description')}
                                    errorMessage={errors.description}
                                />
                            </div>
                        </div>
                        {/* <div className="self-stretch flex flex-col items-start justify-start text-sm">
                            <div className="self-stretch rounded-radius-md  overflow-hidden flex flex-row items-start justify-start pt-2 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] ">
                                <InputsNew
                                    contentPlaceholder="Steps to Reproduce"
                                    label="Steps to Reproduce"
                                    type="textarea"
                                    register={register('stepsToReproduce')}
                                    errorMessage={errors.stepsToReproduce}
                                />
                            </div>
                        </div>
                        <div className="self-stretch flex flex-col items-start justify-start text-sm">
                            <div className="self-stretch rounded-radius-md  overflow-hidden flex flex-row items-start justify-start pt-2 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] ">
                                <InputsNew
                                    contentPlaceholder="Actual Behaviour"
                                    label="Actual Behaviour"
                                    type="textarea"
                                    register={register('actualBehaviour')}
                                    errorMessage={errors.actualBehaviour}
                                />
                            </div>
                        </div>
                        <div className="self-stretch flex flex-col items-start justify-start text-sm">
                            <div className="self-stretch rounded-radius-md  overflow-hidden flex flex-row items-start justify-start pt-2 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] ">
                                <InputsNew
                                    contentPlaceholder="Expected Behaviour"
                                    label="Expected Behaviour"
                                    type="textarea"
                                    register={register('expectedBehaviour')}
                                    errorMessage={errors.expectedBehaviour}
                                />
                            </div>
                        </div> */}
                        <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-4 mq950:mq1275:grid-cols-2 mq575:mq1275:grid-cols-1 gap-[16px] min-w-full">
                            <div className="rounded flex flex-col items-start justify-start text-left min-w-[22%]">
                                <label className="font-semibold dark:text-white pb-2">Add Attachments</label>

                                <div className="flex flex-wrap gap-4 items-center">
                                    {/* Uploaded images */}
                                    {imgUrls.map((url, index) => (
                                        <div key={index} className="bg-white p-2 shadow border rounded relative">
                                            {/* ❌ Delete icon */}
                                            <button
                                                type="button"
                                                onClick={() => handleRemoveImage(index)}
                                                className="absolute top-1 right-1 red-clockout-btn-dv cursor-pointer rounded-full py-[2px] px-[2px] shadow hover:bg-red-100 z-10"
                                                title="Remove image"
                                            >
                                                <span className="text-red-500 font-bold text-lg text-white">×</span>
                                            </button>

                                            <img
                                                className="w-36 h-24 object-cover cursor-pointer"
                                                src={url}
                                                alt={`Uploaded ${index}`}
                                                onClick={() => handleRemoveImage(index)}
                                            />
                                        </div>
                                    ))}

                                    {/* Upload box or uploading state */}
                                    {isUploading ? (
                                        <div className="w-36 h-28 flex items-center justify-center border border-dashed border-neutral-300">
                                            <span className="text-blue-500">Uploading...</span>
                                        </div>
                                    ) : (
                                        <div
                                            className="w-36 h-24 flex flex-col items-center justify-center border border-dashed border-neutral-300 cursor-pointer gap-[8px] "
                                            onClick={handleIconClick}
                                        >
                                            <div className="cursor-pointer flex flex-col items-start justify-start p-[5px] plus-task-btn taskdash-plush-img rounded">
                                                <img src={plusIconuplad} alt="Upload" className="w-5 h-5" />
                                            </div>

                                            <p className="text-sm dark:text-white my-0">Add more</p>
                                        </div>
                                    )}
                                </div>

                                {/* Hidden file input */}
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: "none" }}
                                    onChange={handleFileUpload}
                                    accept=".jpg,.jpeg,.png"
                                    multiple
                                />

                                {/* Error Message */}
                                {validationMessage && (
                                    <p className="text-red-500 text-sm mt-2 flex items-center gap-2">
                                        <span>⚠️</span> {validationMessage}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="self-stretch flex flex-row items-center justify-end py-0 pr-0 gap-[8px] mq950:box-border mq1425:flex-wrap  mq1425:box-border mq450:box-border">
                            <button className="cursor-pointer bg-white py-2.5 h-[44px] mq575:h-[35px] px-[42px] btn-text-purple mq575:py-[12.5px] mq575:px-[25px] rounded-radiuscomponent-button box-border flex flex-row items-center justify-center gap-[12px] border-[2px] border-solid border-surface-primary-surface hover:bg-gainsboro-100 hover:box-border hover:border-[2px] hover:border-solid hover:border-dodgerblue"
                                type="button"
                                onClick={() => navigate(-1)}
                            >
                                <div className="relative text-sm font-body-xs-semi-bold  dark:text-white text-center inline-block">
                                    Cancel
                                </div>
                            </button>
                            <button className={`cursor-pointer [border:none] py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue`}
                                type="submit"
                            >
                                <div className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center inline-block">
                                    Save
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </form >
            {(loading || isUploading) || createDefectLoading && (
                <Loader />
            )}
        </>
    )
}

export default AddTicket